module.exports = __webpack_public_path__ + "img/dialog_bg_2.7d7c97ea.png";